export function AvailableModelsPageSkeleton() {
  return (
    <div className="models-page models-page-skeleton" aria-busy="true">
      <div className="page-loading-bar" aria-hidden="true" />
      <section className="models-summary">
        <div className="models-summary-main">
          <span className="skeleton skeleton-line model-title-skeleton" />
          <span className="skeleton skeleton-line model-copy-skeleton" />
        </div>
        <dl className="models-summary-grid">
          {[0, 1].map((index) => (
            <div className="model-summary-stat" key={index}>
              <dt>
                <span className="skeleton skeleton-line model-stat-label-skeleton" />
              </dt>
              <dd>
                <span className="skeleton skeleton-line model-stat-value-skeleton" />
              </dd>
            </div>
          ))}
        </dl>
      </section>
      <section className="models-toolbar">
        <span className="skeleton model-search-skeleton" />
        <span className="skeleton model-refresh-skeleton" />
        <div className="models-provider-strip">
          {[0, 1, 2, 3].map((index) => (
            <span className="skeleton model-chip-skeleton" key={index} />
          ))}
        </div>
      </section>
      <div className="models-list">
        <table className="models-table">
          <colgroup>
            <col className="model-col-identity" />
            <col className="model-col-price" />
            <col className="model-col-price" />
            <col className="model-col-price" />
            <col className="model-col-price" />
            <col className="model-col-updated" />
          </colgroup>
          <tbody>
            {Array.from({ length: 8 }).map((_, index) => (
              <tr className="model-row model-row-skeleton" key={index}>
                <th className="model-identity-cell" scope="row">
                  <div className="model-identity">
                    <span className="skeleton model-id-skeleton" />
                    <span className="skeleton model-copy-button-skeleton" />
                  </div>
                </th>
                {[0, 1, 2, 3].map((priceIndex) => (
                  <td className="model-price-cell" key={priceIndex}>
                    <span className="skeleton model-price-skeleton" />
                  </td>
                ))}
                <td className="model-updated-cell">
                  <span className="skeleton model-updated-skeleton" />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
